import { createContext, useContext, useEffect, useState } from "react";
import api, { TOKEN_KEY, apiErr } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=auth
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) { setUser(false); setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem(TOKEN_KEY); setUser(false); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (identifier, password) => {
    const { data } = await api.post("/auth/login", { identifier, password });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
    window.location.href = "/login";
  };

  const role = user?.role;
  const isEditor = !!user && ["OWNER", "ACCOUNTING", "ADMIN"].includes(role);
  const isOwner = !!user && ["OWNER", "ACCOUNTING"].includes(role);
  const canManageUsers = !!user && role === "OWNER";
  const isOperator = !!user && role === "PENCATAT";

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, logout, isEditor, isOwner, canManageUsers, isOperator }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { apiErr };
